<script setup>
import {onMounted, ref} from 'vue';
import BaseInputFloatingLabelNumber from "@/components/forms/BaseInputFloatingLabelNumber.vue";
import {useMatchedBetStore} from '@/stores/MatchedBetStore';
import {useOddsmatcherStore} from "@/stores/OddsmatcherStore";
import {storeToRefs} from "pinia";
import BaseSelectContainerStyle1 from "@/components/forms/BaseSelectContainerStyle1.vue";

const matchedBetStore = useMatchedBetStore();
const {backBetData, oddsmatcherData, layBetData} = storeToRefs(matchedBetStore);

const oddsmatcherStore = useOddsmatcherStore();

const isAdvancedVisible = ref(false);
onMounted(async () => {
  await oddsmatcherStore.fetchAndUpdateData();
})
</script>


<template>
  <div class="oddsmatcher-settings-container">
    <BaseSelectContainerStyle1
        v-model="backBetData.type"
        :options="matchedBetStore.basicMatchedBetTypes"
        label="Bet Type:"
    />

    <BaseSelectContainerStyle1
        v-model="oddsmatcherData.bookie"
        :options="oddsmatcherStore.bookies"
        label="Bookie"/>

    <div class="oddsmatcher-floating-input-container">
      <BaseInputFloatingLabelNumber
          :config="{ label: 'Stake (£)', name: 'back-stake', hasClearButton: false, classes: { error: 'has-error' }}"
          v-model="backBetData.stake"/>

      <BaseInputFloatingLabelNumber
          v-if="backBetData.type==='rf'"
          :config="{ label: 'Loss Value (£)', name: 'back-loss-value', hasClearButton: false, classes: { error: 'has-error' } }"
          v-model="backBetData.lossValue"/>
    </div>

    <div class="oddsmatcher-advanced-settings">
      <label>
        <input type="checkbox" v-model="isAdvancedVisible"/> Advanced Settings
      </label>
    </div>

    <div v-if="isAdvancedVisible" style="padding: 1rem">
      <BaseInputFloatingLabelNumber
          :config="{ label: 'Back Commission (%)', name: 'back-commission', hasClearButton: false, classes: { error: 'has-error' } }"
          v-model="backBetData.commission"/>

      <BaseInputFloatingLabelNumber
          :config="{ label: 'Lay Commission (%)', name: 'lay-commission', hasClearButton: false, classes: { error: 'has-error' } }"
          v-model="layBetData.commission"/>

      <BaseInputFloatingLabelNumber
          :config="{ label: 'Max Liability (£)', name: 'max-liability', hasClearButton: false, classes: { error: 'has-error' } }"
          v-model="oddsmatcherData.maxLiability"/>
    </div>
  </div>
</template>


<style scoped>
.oddsmatcher-settings-container {
  background-color: var(--clr-black-10);
  padding: 1rem;
  min-width: min(100vw, 576px); /* Ensure minimum width of 100vw or 576px, whichever is smaller */
}

.oddsmatcher-advanced-settings {
  display: flex;
  align-items: center;
  padding: 1rem;
}

.oddsmatcher-advanced-settings label {
  display: flex;
  align-items: center;
  gap: 10px; /* Adjust the gap as needed */
}

.oddsmatcher-advanced-settings input[type="checkbox"] {
  margin: 0;
}

.oddsmatcher-floating-input-container {
  padding: 1rem;
  margin: 0;
}

</style>
